import { device } from 'component-library/styles/device';
import styled from 'styled-components';

import { bodies, Body } from './Body';

interface ResponsiveBodyProps {
  maxWidth?: number;
}

const responsiveBodyStyles = (medium: boolean) => ({
  1: {
    lg: {
      fontSize: bodies(medium)[4].fontSize,
      lineHeight: bodies(medium)[4].lineHeight,
    },
    xl: {
      fontSize: bodies(medium)[3].fontSize,
      lineHeight: bodies(medium)[3].lineHeight,
    },
  },
  2: {
    lg: {
      fontSize: bodies(medium)[4].fontSize,
      lineHeight: bodies(medium)[4].lineHeight,
    },
    xl: {
      fontSize: bodies(medium)[3].fontSize,
      lineHeight: bodies(medium)[3].lineHeight,
    },
  },
  3: {
    lg: {
      fontSize: bodies(medium)[4].fontSize,
      lineHeight: bodies(medium)[4].lineHeight,
    },
    xl: {
      fontSize: bodies(medium)[4].fontSize,
      lineHeight: bodies(medium)[4].lineHeight,
    },
  },
  4: {
    lg: {
      fontSize: bodies(medium)[4].fontSize,
      lineHeight: bodies(medium)[4].lineHeight,
    },
    xl: {
      fontSize: bodies(medium)[4].fontSize,
      lineHeight: bodies(medium)[4].lineHeight,
    },
  },
  5: {
    lg: {
      fontSize: bodies(medium)[5].fontSize,
      lineHeight: bodies(medium)[5].lineHeight,
    },
    xl: {
      fontSize: bodies(medium)[5].fontSize,
      lineHeight: bodies(medium)[5].lineHeight,
    },
  },
});

export const ResponsiveBody = styled(Body)<ResponsiveBodyProps>`
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : 'unset')};

  ${`@media ${device.lg}`} {
    font-size: ${({ variant, medium = false }) =>
      responsiveBodyStyles(medium)[variant].lg.fontSize};
    line-height: ${({ variant, medium = false }) =>
      responsiveBodyStyles(medium)[variant].lg.lineHeight};
  }

  ${`@media ${device.xl}`} {
    font-size: ${({ variant, medium = false }) =>
      responsiveBodyStyles(medium)[variant].xl.fontSize};
    line-height: ${({ variant, medium = false }) =>
      responsiveBodyStyles(medium)[variant].xl.lineHeight};
  }

  ${`@media ${device.xxl}`} {
    font-size: ${({ variant, medium = false }) =>
      bodies(medium)[variant].fontSize};
    line-height: ${({ variant, medium = false }) =>
      bodies(medium)[variant].lineHeight};
  }
`;
